import { render, staticRenderFns } from "./SectionCategoryItem.vue?vue&type=template&id=1c39b2fa&scoped=true&lang=pug&"
import script from "./SectionCategoryItem.vue?vue&type=script&lang=js&"
export * from "./SectionCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./SectionCategoryItem.vue?vue&type=style&index=0&id=1c39b2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39b2fa",
  null
  
)

export default component.exports